export const hotels = [
  {
    id: "tulia",
    title: "Tulia Zanzibar Unique Beach Resort",
    location: "Pongwe",
    shortDescription: "Luxury beachfront resort with pools and private beach.",
    longContent: {
      intro: `Tulia Zanzibar Unique Beach Resort is a five-star property located on the tranquil Pongwe coast. 
Guests are welcomed into spacious villas with private terraces, lush gardens, and direct access to the beach. 
The resort features two swimming pools, including one overlooking the ocean, and a private stretch of white sand. 
Dining is a highlight, with chefs preparing gourmet meals that blend international flavors with fresh local ingredients. 
The spa offers rejuvenating treatments inspired by Swahili traditions, while yoga sessions on the beach provide relaxation.`,
      gallery: [
        "/images/tulia1.webp",
        "/images/tulia2.webp",
        "/images/tulia3.webp",
        "/images/tulia4.webp",
        "/images/tulia5.webp"
      ],
      prices: {
        currency: "USD",
        note: "Rates per room per night. Seasonal variations may apply. Taxes and service fees may be additional.",
        table: [
          { roomType: "Garden Villa", occupancy: "2 adults", rateUSD: 280, rateTZS: 280000 },
          { roomType: "Ocean View Villa", occupancy: "2 adults", rateUSD: 360, rateTZS: 360000 },
          { roomType: "Family Villa (2BR)", occupancy: "4 adults", rateUSD: 520, rateTZS: 520000 }
        ]
      },
      details: `Activities include snorkeling, diving, and cultural excursions to nearby villages. 
Families appreciate the child-friendly amenities, while couples enjoy romantic sunset dinners. 
Sustainability is a core value, with eco-friendly practices integrated into daily operations. 
Tulia combines luxury, culture, and nature, making it one of Zanzibar’s most exclusive escapes.`
    },
    image: "/images/tulia.jpg",
    galleryLayout: "grid-4",
    cta: {
      readMore: { label: "Read More", href: "/hotels/tulia" },
      inquire: { label: "Inquire", href: "/contact" }
    },
    type: "hotels",
    rating: 5
  },

  {
    id: "gold-zanzibar",
    title: "Gold Zanzibar Beach House & Spa",
    location: "Nungwi",
    shortDescription: "Stylish rooms with terraces overlooking the Indian Ocean.",
    longContent: {
      intro: `Gold Zanzibar Beach House & Spa is located on the famous Nungwi Beach, offering breathtaking views of the Indian Ocean. 
The resort features elegantly designed rooms and suites, each with private terraces or verandas. 
Guests can indulge in spa treatments that combine African and Asian techniques, or relax by the infinity pool.`,
      gallery: [
        "/images/gold1.webp",
        "/images/gold2.webp",
        "/images/gold3.webp",
        "/images/gold4.jpg"
      ],
      prices: {
        currency: "USD",
        note: "Per room per night. Breakfast included for most rates. Seasonal supplements may apply.",
        table: [
          { roomType: "Superior Room", occupancy: "2 adults", rateUSD: 220, rateTZS: 220000 },
          { roomType: "Deluxe Sea View", occupancy: "2 adults", rateUSD: 320, rateTZS: 320000 },
          { roomType: "Suite", occupancy: "2 adults", rateUSD: 480, rateTZS: 480000 }
        ]
      },
      details: `Dining options include beachfront restaurants serving fresh seafood, Italian specialties, and Swahili-inspired dishes. 
The resort organizes water sports such as diving, snorkeling, and deep-sea fishing.`
    },
    image: "/images/goldhouse.webp",
    galleryLayout: "grid-4",
    cta: {
      readMore: { label: "Read More", href: "/hotels/gold-zanzibar" },
      inquire: { label: "Inquire", href: "/contact" }
    },
    type: "hotels",
    rating: 5
  },

  {
    id: "white-sand",
    title: "Zanzibar White Sand Luxury Villas & Spa",
    location: "Paje",
    shortDescription: "Luxury villas, spa and beachfront dining.",
    longContent: {
      intro: `Zanzibar White Sand Luxury Villas & Spa is a Relais & Châteaux property located on Paje Beach. 
Each villa offers private pools, spacious living areas, and direct beach access.`,
      gallery: [
        "/images/whitesand-1.jpg",
        "/images/whitesand-2.jpg",
        "/images/whitesand-3.jpg",
        "/images/whitesand-4.jpg"
      ],
      prices: {
        currency: "USD",
        note: "Rates shown per villa per night. Includes selected meals depending on rate plan.",
        table: [
          { roomType: "One-Bedroom Villa", occupancy: "2 adults", rateUSD: 420, rateTZS: 420000 },
          { roomType: "Two-Bedroom Villa", occupancy: "4 adults", rateUSD: 680, rateTZS: 680000 },
          { roomType: "Private Pool Villa", occupancy: "2 adults", rateUSD: 750, rateTZS: 750000 }
        ]
      },
      details: `The resort’s spa is set in a tropical garden, offering massages, hammam rituals, and wellness therapies. 
Guests can enjoy kite surfing, snorkeling, and excursions to nearby islands. 
Sustainability is central, with solar energy, organic gardens, and eco-friendly construction.`
    },
    image: "/images/whitesand.webp",
    galleryLayout: "grid-4",
    cta: {
      readMore: { label: "Read More", href: "/hotels/white-sand" },
      inquire: { label: "Inquire", href: "/contact" }
    },
    type: "hotels",
    rating: 5
  },

  {
    id: "forodhani",
    title: "Forodhani Park Hotel",
    location: "Stone Town",
    shortDescription: "Central budget-friendly hotel.",
    longContent: {
      intro: `Forodhani Park Hotel is located in the heart of Stone Town, just steps from the famous Forodhani Gardens. 
The hotel offers affordable rooms with modern amenities, making it ideal for budget-conscious travelers.`,
      gallery: [
        "/images/foropark-1.jpg",
        "/images/foropark-2.jpg",
        "/images/foropark-3.jpg"
      ],
      prices: {
        currency: "USD",
        note: "Budget-friendly rates. Breakfast included on most plans.",
        table: [
          { roomType: "Standard Room", occupancy: "2 adults", rateUSD: 45, rateTZS: 45000 },
          { roomType: "Superior Room", occupancy: "2 adults", rateUSD: 65, rateTZS: 65000 },
          { roomType: "Family Room", occupancy: "3-4 adults", rateUSD: 90, rateTZS: 90000 }
        ]
      },
      details: `Guests enjoy easy access to Stone Town’s historic sites, markets, and waterfront. 
The rooftop terrace provides panoramic views of the city and ocean, perfect for sunset relaxation.`
    },
    image: "/images/foroparkhotel.jpg",
    galleryLayout: "grid-3",
    cta: {
      readMore: { label: "Read More", href: "/hotels/forodhani" },
      inquire: { label: "Inquire", href: "/contact" }
    },
    type: "hotels",
    rating: 4
  },

  {
    id: "kisiwa",
    title: "Kisiwa House Hotel",
    location: "Stone Town",
    shortDescription: "Historic boutique stay.",
    longContent: {
      intro: `Kisiwa House Hotel is a historic boutique property in Stone Town, blending Swahili architecture with modern luxury. 
Originally built in the 19th century, the hotel has been carefully restored to preserve its heritage.`,
      gallery: [
        "/images/kisiwa-1.jpg",
        "/images/kisiwa-2.jpg",
        "/images/kisiwa-3.jpg"
      ],
      prices: {
        currency: "USD",
        note: "Boutique hotel pricing. Rates may include breakfast.",
        table: [
          { roomType: "Classic Room", occupancy: "2 adults", rateUSD: 95, rateTZS: 95000 },
          { roomType: "Deluxe Room", occupancy: "2 adults", rateUSD: 140, rateTZS: 140000 },
          { roomType: "Suite", occupancy: "2 adults", rateUSD: 220, rateTZS: 220000 }
        ]
      },
      details: `Rooms feature carved wooden furniture, high ceilings, and elegant decor. 
Guests can dine at the rooftop restaurant, which offers panoramic views of Stone Town and the ocean.`
    },
    image: "/images/kisiwahouse.avif",
    galleryLayout: "grid-3",
    cta: {
      readMore: { label: "Read More", href: "/hotels/kisiwa" },
      inquire: { label: "Inquire", href: "/contact" }
    },
    type: "hotels",
    rating: 4
  },

  {
    id: "kendwa-rocks",
    title: "Kendwa Rocks Beach Hotel",
    location: "Kendwa",
    shortDescription: "Beachfront hotel famous for sunsets and lively atmosphere.",
    longContent: {
      intro: `Kendwa Rocks Beach Hotel is located on Kendwa Beach, one of Zanzibar’s most beautiful stretches of sand. 
The hotel is renowned for its vibrant atmosphere, beachfront parties, and stunning sunset views.`,
      gallery: [
        "/images/kendwa-1.jpg",
        "/images/kendwa-2.jpg",
        "/images/kendwa-3.jpg",
        "/images/kendwa-4.jpg"
      ],
      prices: {
        currency: "USD",
        note: "Popular with groups and younger travelers. Rates vary by season and event nights.",
        table: [
          { roomType: "Beach Bungalow", occupancy: "2 adults", rateUSD: 120, rateTZS: 120000 },
          { roomType: "Sea View Room", occupancy: "2 adults", rateUSD: 160, rateTZS: 160000 },
          { roomType: "Family Suite", occupancy: "4 adults", rateUSD: 240, rateTZS: 240000 }
        ]
      },
      details: `Activities include swimming, snorkeling, diving, and boat trips, while the lively nightlife makes Kendwa Rocks a favorite among younger travelers and groups.`
    },
    image: "/images/kendwarocks.webp",
    galleryLayout: "grid-4",
    cta: {
      readMore: { label: "Read More", href: "/hotels/kendwa-rocks" },
      inquire: { label: "Inquire", href: "/contact" }
    },
    type: "hotels",
    rating: 4
  },

  {
    id: "blackstone-uroa",
    title: "Blackstone Hotel",
    location: "Uroa",
    shortDescription: "Comfortable beachfront hotel with modern amenities and local charm.",
    longContent: {
      intro: `Blackstone Hotel Uroa is a welcoming mid-range property located on the peaceful Uroa coastline. 
The hotel offers comfortable rooms and family suites with sea-view balconies and contemporary furnishings.`,
      gallery: [
        "/images/blackstone-1.jpg",
        "/images/blackstone-2.jpg",
        "/images/blackstone-3.jpg",
        "/images/blackstone-4.jpg"
      ],
      prices: {
        currency: "USD",
        note: "Good value options for families and couples. Rates shown per room per night.",
        table: [
          { roomType: "Standard Room", occupancy: "2 adults", rateUSD: 75, rateTZS: 75000 },
          { roomType: "Sea View Room", occupancy: "2 adults", rateUSD: 110, rateTZS: 110000 },
          { roomType: "Family Suite", occupancy: "4 adults", rateUSD: 160, rateTZS: 160000 }
        ]
      },
      details: `Guests can relax by the outdoor pool, enjoy fresh seafood at the on-site restaurant, or take leisurely walks along the nearby beach. 
Blackstone arranges local excursions including spice tours, village visits, and boat trips to nearby islands.`
    },
    image: "/images/blackstone.webp",
    galleryLayout: "grid-4",
    cta: {
      readMore: { label: "Read More", href: "/hotels/blackstone-uroa" },
      inquire: { label: "Inquire", href: "/contact" }
    },
    type: "hotels",
    rating: 4
  }
];
